import React, { useMemo } from "react";
import { connect } from "react-redux";

import MapArea from "components/MapArea";

import MapUtils from "services/map/utils";

function AislesLayers({ availableParking, currentFloor, map }) {
  const numberOfAvailableSpotsByAisle = useMemo(() => {
    return availableParking?.items
      ?.filter((spot) => spot.type !== "unavailable")
      .reduce((acc, availableSpot) => {
        const currentSpotAisle = availableSpot?.meta_data?.parking?.aisle;
        if (currentSpotAisle) {
          return {
            ...acc,
            [currentSpotAisle]: (acc?.[currentSpotAisle] || 0) + 1,
          };
        }

        return acc;
      }, {});
  }, [availableParking?.items]);

  if (!map?.initialized || !availableParking?.initialized) {
    return null;
  }

  return map?.aisles
    ?.filter((aisle) =>
      currentFloor || currentFloor === 0
        ? aisle.floor_level === currentFloor
        : aisle
    )
    .map((aisle) => {
      const aisleName = `${aisle?.name} : ${
        numberOfAvailableSpotsByAisle?.[aisle?.name] || "0"
      }`;

      return (
        <MapArea
          key={aisle.name}
          positions={MapUtils.getNormalizedAreaCoordinates(
            aisle?.polygon || []
          )}
          options={{
            ...(aisle?.options || {}),
            tooltipCoordinates: aisle?.location,
            withLabel: true,
          }}
          label={aisleName}
        />
      );
    });
}

const mapStateToProps = (state) => ({
  availableParking: state.AvailableParking.list,
  currentFloor: MapUtils.getFloor(state.Map),
  map: state.ParkStatistics.map,
});

export default connect(mapStateToProps)(AislesLayers);
